import { JsonObject, JsonProperty, AbstractModel, DateConverter } from 'projects/core/src/public-api';
import { CheckItemTag } from './checkitem-tag';

@JsonObject('model.CheckItemHeadTag')
export class CheckItemHeadTag extends AbstractModel {
    @JsonProperty(Number, 'id')
    id: number;

    @JsonProperty(Number, 'amount')
    amount?: number;

    @JsonProperty(String, 'name')
    name?: string;

    @JsonProperty(Boolean, 'ready')
    ready?: boolean;

    @JsonProperty(CheckItemTag, 'type')
    type?: CheckItemTag;

    @JsonProperty(String, 'invoiceId')
    invoiceId?: string;

    @JsonProperty(DateConverter, 'sentDate')
    sentDate?: Date;

    @JsonProperty(DateConverter, 'paidDate')
    paidDate?: Date;
}